import { render, staticRenderFns } from "./courseIntroduce.vue?vue&type=template&id=6d359f38&scoped=true"
import script from "./courseIntroduce.vue?vue&type=script&lang=js"
export * from "./courseIntroduce.vue?vue&type=script&lang=js"
import style0 from "./courseIntroduce.vue?vue&type=style&index=0&id=6d359f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d359f38",
  null
  
)

export default component.exports